import type { RutaProd } from '../../../../runtime/rutas';
export default {
  ruta: '/sistema/crm/Chats',
  alias: ['/sistema/crm/Chats/Index'],
  documento: 'crm',
  filas: ['147'],
  acceso: 'sesion',
  cita: 'prod:Areas/CRM/Controllers/ChatsController.cs',
} satisfies RutaProd;
